import {Attachment, ParameterRow} from '@irvin-group/airtable-data-types';

export function objectToParameterRows(obj: Object): ReadonlyArray<ParameterRow>
{
  return Object.entries(obj).map(([ key, value ]) => {
    return {
      Parameter: key,
      Value: `${value}`,
      Content: '',
      Image: [ ]
    };
  });
}

export default class ParameterMap
{
  protected _data = new Map<string, ParameterRow[]>();

  constructor(rows: ReadonlyArray<ParameterRow>)
  {
    const map = this._data;

    for (const d of rows) {
      const name = d.Parameter;

      if (!map.has(name)) {
        map.set(name, [ ]);
      }

      const entry = map.get(name);
      if (entry) {
        entry.push(d);
      }
      else {
        throw new Error();
      }

    }
  }

  getArray(name: string): ReadonlyArray<ParameterRow>
  {
    const rows = this._data.get(name);

    if (!rows) {
      return [ ];
    }

    return rows;
  }

  getSingle(name: string): Readonly<ParameterRow>
  {
    const rows = this._get(name);

    if (rows.length !== 1) {
      throw new Error(`Property ${name} has ${rows.length} rows (expected a single row)`);
    }

    return rows[0];
  }

  getSingleOrNull(name: string): Readonly<ParameterRow> | null
  {
    if (!this._data.has(name)) {
      return null;
    }

    return this.getSingle(name);
  }

  getValue(name: string): string
  {
    return this.getSingle(name).Value || '';
  }

  getImage(name: string): Attachment
  {
    const attachments = this.getSingle(name).Image;

    if (attachments.length !== 1) {
      throw new Error(`Image field for ${name} has ${attachments.length} attachments; expected 1`);
    }

    return attachments[0];
  }

  /**
   * source from airtable and treat the value as bool... missing or text value
   * "false" will return false. Anything else will return true
   */
  getValueAsBoolOrNull(name: string): boolean | null
  {
    const val = this.getValueOrNull(name);

    if (val === null) {
      return null;
    }

    if (val.toLowerCase() === 'false') {
      return false;
    }

    return true;
  }

  getValueOrNull(name: string): string | null
  {
    const entry = this.getSingleOrNull(name);

    return entry ? entry.Value : null;
  }

  getContentOrNull(name: string): string | null
  {
    const entry = this.getSingleOrNull(name);

    return entry ? entry.Content : null;
  }

  getContent(name: string): string
  {
    return this.getSingle(name).Content || '';
  }

  private _get(name: string): ReadonlyArray<ParameterRow>
  {
    const rows = this._data.get(name);

    if (!rows) {
      throw new Error(`invalid parameter name: ${name}`);
    }

    return rows;
  }
}
